<template>
  <div class="card-columns">
    <div class="container">
      <div class="c-title">
        <h1>讲堂</h1>
        <h3>
          <a href="https://time.geekbang.org/paid-content" target="_blank">查看更多></a>
        </h3>
      </div>
      <ul class="columns">
        <li class="column is-one-third-tablet" v-for="(column, index) in columns" :key="index">
          <a :href="`https://time.geekbang.org/${column.column_type===1?'column':'course'}/intro/${column.column_id}`" target="_blank" v-if="column.column_cover_wxlite">
            <div class="img">
              <img :src="column.column_cover_wxlite" alt="">
            </div>
            <div class="wrapper">
              <div class="title">
                <h3>{{column.column_title}}</h3>
                <span>{{column.column_subtitle}}</span>
              </div>
              <div class="profile">{{getTime(column.article_ctime) + '《' + column.article_title + '》'}}</div>
            </div>
          </a>
        </li>
      </ul>
      <!-- <div class="more">
        <a href="//time.geekbang.org/columns" target="_blank">查看更多</a>
      </div> -->
    </div>
  </div>
</template>
<script>
import TimeService from '@/service/time.service.js'

export default {
  data () {
    return {
      columns: []
      // covers: {
      //   63: 'https://static.geekbang.org/infoq/5a979bf9d1220.png?imageView2/0/',
      //   62: 'https://static.geekbang.org/infoq/5a979ed3123b1.png?imageView2/0/',
      //   50: 'https://static.geekbang.org/infoq/5a979bf7aece6.png?imageView2/0/',
      //   49: 'https://static.geekbang.org/infoq/5a979ed203710.png?imageView2/0/',
      //   48: 'https://static.geekbang.org/infoq/5a979ed3600f2.png?imageView2/0/',
      //   43: 'https://static.geekbang.org/infoq/5a979bf910398.png?imageView2/0/',
      //   42: 'https://static.geekbang.org/infoq/5a979bf956031.png?imageView2/0/',
      //   74: 'https://static.geekbang.org/infoq/5a979ed529caf.png?imageView2/0/'
      // }
    }
  },
  components: {},
  created () {
    // this.getColumns()
    Promise.all([this.getColumns('rec_article_1', 3), this.getColumns('rec_article_2', 3)]).then(v => { this.columns = v[0].concat(v[1]) })
  },
  methods: {
    getColumns (blockName, size) {
      return new Promise((resolve, reject) => {
        TimeService.getColumns({ block_name: blockName, size: size })
          .then(data => {
            // console.log(data)
            resolve(data.list)
          })
          .catch(err => { reject(err) })
      })
      // return new Promise((resolve, reject) => {
      //   if (config.API_ENV === 'dev') {
      //     this.$ajax.get(config.API_COURSE).then(res => {
      //       if (res.status === 200 && res.data.code === 0) {
      //         this.columns = res.data.data.list
      //         // console.log(this.columns)
      //         resolve(res.data.data.list)
      //       } else {
      //         reject()
      //       }
      //     })
      //   } else if (config.API_ENV === 'prod') {
      //     this.$ajax.post(config.API_COURSE, {
      //       block_name: 'explore_column',
      //       size: 10
      //     }, {
      //       headers: {'content-type': 'text/plain'}
      //     }).then(res => {
      //       if (res.status === 200 && res.data.code === 0) {
      //         this.columns = res.data.data.list
      //         resolve(res.data.data.list)
      //       } else {
      //         reject()
      //       }
      //     })
      //   }
      // })
    },
    getTime (s) {
      var timeDiff = Number(Date.parse(new Date()) / 1000) - Number(s)
      if (timeDiff >= 3600 * 24 * 7) {
        return '最近更新： '
      } else if (timeDiff >= 3600 * 24) {
        return Math.floor(timeDiff / (3600 * 24)) + '天前更新： '
      } else if (timeDiff >= 3600) {
        return Math.floor(timeDiff / 3600) + '小时前更新： '
      } else if (timeDiff >= 60) {
        return Math.floor(timeDiff / 60) + '分钟前更新： '
      } else {
        return timeDiff + '秒前更新： '
      }
    }
  },
  computed: {}
}
</script>
<style scoped lang='sass'>
@import '~@/style/variable.sass'

.card-columns
  background-color: #f5f5f5
  .container
    margin: 0 auto
    overflow: hidden
    padding: 1rem
    .c-title
      display: flex
      justify-content: space-between
      align-items: flex-end
      +mobile
        align-items: center
      h1
        font-size: 1.8rem
      h3
        font-size: 16px
        color: #888
    .columns
      margin-top: 0.4rem
      flex-wrap: wrap
      +mobile
      .column
        padding: 0.88rem
        &:nth-child(n+7)
          display: none
        +mobile
          padding: 0.75rem
          &:nth-child(n+4)
            display: none
        a
          display: block
          background-color: #fff
          overflow: hidden
          box-shadow: 0px 4px 8px 0px rgba(7, 17, 27, 0.1)
          transition: 0.3s all linear
          &:hover
            box-shadow: 0px 8px 16px 0px rgba(7, 17, 27, 0.2)
          .img
            position: relative
            &:before
              content: ''
              display: inline-block
              width: 0.1px
              padding-top: 47.8%
            img
              position: absolute
              left: 0
              top: 0
              width: 100%
              height: 100%
          .wrapper
            padding: 15px
            .title
              margin-bottom: 10px
              h3
                font-size: 20px
              span
                font-size: 12px
                color: #888
            .profile
              color: #353553
              font-size: 12px
              height: 36px
              +limit-line-numbers(2)
    .more
      display: flex
      justify-content: center
      margin-top: 30px
      a
        display: block
        border: 1px solid #888
        border-radius: 20px
        padding: 8px 40px
        +mobile
          padding: 5px 35px

</style>
